// src/components/Canonical.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Canonical() {
  const location = useLocation();

  useEffect(() => {
    // Construct canonical without the hash (#/)
    const cleanPath = location.pathname + location.search;
    const canonicalUrl = "https://ethirapropertygroup.co.uk" + cleanPath;

    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);

  }, [location]);

  return null;
}
